import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { ArrowRight } from "lucide-react";

export default function CheckoutCancel() {
  return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center px-6">
      <div className="max-w-lg text-center">
        <h1 className="text-3xl md:text-4xl mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
          Your Build Is Waiting.
        </h1>
        
        <div className="space-y-4 text-[#2C2C2C]/70 font-light mb-10">
          <p>
            It looks like your payment wasn't completed.
          </p>
          <p>
            If this was unintentional, you can return and complete your purchase below.
          </p>
          <p className="text-[#2C2C2C]/60">
            Calm Scale™ remains available when you're ready.
          </p>
        </div>

        <Link to="/checkout">
          <Button 
            className="btn-primary text-base px-8 py-4"
            data-testid="return-to-checkout-btn"
          >
            Return to Checkout
            <ArrowRight className="ml-2 w-4 h-4" />
          </Button>
        </Link>

        <div className="mt-8">
          <Link to="/" className="text-sm text-[#2C2C2C]/40 hover:text-[#6B8E7C] transition-colors">
            ← Return to Calm Scale™
          </Link>
        </div>
      </div>
    </div>
  );
}
